import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';

export const PickersUtilsProvider = ({ children }) => (
  <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
    {children}
  </LocalizationProvider>
);

PickersUtilsProvider.propTypes = {
  children: PropTypes.node
};

export default PickersUtilsProvider;
